import React from "react";
import { useState, useEffect } from "react";
import './header.css';

function Header(props) {
  const { userType, onLogout, onSearch } = props;
  const [userName, setUserName] = useState('');
  const [startDate, setStartDate] = useState(new Date(new Date().setMonth(new Date().getMonth() - 4)).toJSON().slice(0, 10));
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleIconClick = () => {
    setIsDialogOpen(true);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleFnc = () => {
    props.chooseMessage(startDate, endDate)
  }

  useEffect(() => {
    const user = localStorage.getItem('currentUser');
    if (user) {
      const parsedUser = JSON.parse(user);
      setUserName(parsedUser?.email || '');
    }

  }, []);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <div className="header-container d-flex flex-row justify-content-between align-items-center">
      <div className="left d-flex flex-row align-items-center">
        <img src={require('../../assets/DA.png')} alt="DAlgorithms Logo" />
        <img src={require('../../assets/Group 2.png')} height="100%" width="80%" alt="Authenticate" />
      </div>
      <div className="right-main d-flex flex-row align-items-center justify-content-around">
        {userType !== "super_admin" && (
          <div className="middle d-flex flex-row justify-content-around align-items-center">
            <div className="start d-flex flex-row justify-content-between align-items-center">
              <label>Start Date : </label>
              <input type="date" id="start" name="startDate" max="{{end_date | date:'yyyy-MM-dd'}}"
                value={startDate}
                onChange={handleStartDateChange} />
            </div>
            <div className="end d-flex flex-row justify-content-between align-items-center">
              <label>End Date : </label>
              <input type="date" id="end" name="endDate" min="{{start_date | date:'yyyy-MM-dd'}}"
                value={endDate}
                onChange={handleEndDateChange} />
            </div>
            <input className="submit" value="Submit" type="submit" onClick={handleFnc} />
            <div className="search d-flex flex-row justify-content-between align-items-center">
              <input value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} placeholder="UserID" name="search" type="text" onKeyUp={handleSearch} />
              <img src={require('../../assets/search.png')} height="100%" width="80%" alt="search" />
            </div>
          </div>
        )}
        <div className="right d-flex flex-row justify-content-around align-items-center">
          <div className="picture" >
            <img src={require('../../assets/Avatar.png')} alt="Ava" onClick={handleIconClick} />
            {isDialogOpen && <div className="overlay" onClick={() => setIsDialogOpen(false)} />}
            {isDialogOpen && (
              <div className="dialog">
                <div className="option">
                  <div><img src={require('../../assets/account_circle_colour.png')} alt="Ava"></img></div>
                  <div style={{ marginLeft: "0.5rem", marginTop: "0.5rem" }}>{userName}</div>
                </div>
                <div className="option" onClick={onLogout}>
                  <div><img src={require('../../assets/logout.png')} alt="Ava"></img></div>
                  <div style={{ marginLeft: "0.5rem" }}>Logout</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;